
import { Options, Vue } from "vue-class-component";
import { useStore } from "../store";
import { MutationTypes } from "../store/mutation-types";
import { sortedDays, filterData } from "../data/functions";
import { useRoute } from "vue-router";

@Options({
  props: {
    category: Array,
    roundedStyle: Boolean,
  },
  methods: {
    activeButton(value: number) {
      const push = (f: string) => {
        return this.store.commit(MutationTypes.SET_DAY_MENU, {
          number: 0,
          filter: f,
          menu: value,
        });
      };

      if (this.route.path.includes("schedule")) {
        // if the component is in Schedule.vue
        // puts the first day name (DayMenu) in the state when either button is clicked
        return push(sortedDays()[0]);
      } else {
        // if the component is in any other screen (Main.vue)
        // puts the first day name (DayMenu) in the state if the third button is clicked
        const filter = value === 2 ? sortedDays()[0] : "";
        return push(filter);
      }
    }, // sets the style (rounded or squared)
    chooseDisplay(index: number) {
      const menu = this.$store.state.activeDayMenu.menu;
      const two = this.category.length === 2;

      if (index === menu) {
        return "button-div-active";
      } else if (index != menu) {
        return "button-div";
      } else if (two && index === 0 && menu === index) {
        return "first-div-active";
      } else if (two && index === 0 && menu != 0) {
        return "first-div";
      } else if (two && index != 0 && menu === index) {
        return "second-div-active";
      } else {
        return "second-div";
      }
    },
  },
})
export default class SortByMenu extends Vue {
  category!: string[];
  roundedStyle!: boolean;
  store = useStore();
  route = useRoute();
  sortedDays = sortedDays;
  filterData = filterData;
}
